import { render, staticRenderFns } from "./StaffIndex.vue?vue&type=template&id=18305e92&scoped=true&"
import script from "./StaffIndex.vue?vue&type=script&lang=js&"
export * from "./StaffIndex.vue?vue&type=script&lang=js&"
import style0 from "./StaffIndex.vue?vue&type=style&index=0&id=18305e92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18305e92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
